<template>
  <div class="wrap">
    <div class="notice">
      <p class="text">{{name}}同学，您好：</p>
      <p class="text">欢迎您参加<em>{{exam_name}}</em>科目考试，请仔细阅读考试须知，确认了解所有信息点击“开始考试”按钮即可开始考试</p>
      <p class="title">考生考试须知</p>
      <p class="line"></p>
      <p class="text">1、考生应诚信考试并自觉服从监考员等考试工作人员管理，不得以任何理由妨碍监考员等考试工作人员履行职责，不得扰乱考场及其他考试工作地点的秩序</p>
      <p class="text">2、凭《准考证》和身份证、户口本等有效身份证件，按规定时间和地点参加考试。</p>
      <p class="text">3、考生入场，除2B铅笔、书写黑色字迹的签字笔、直尺、圆规、三角板、橡皮外，其他任何物品不准带入考场。</p>
      <p class="text">4、考生入场后，对号入座，将《准考证》、身份证等证件放在桌子上以便核验。</p>
      <p class="text">5、开考信号发出后方可开始答题。</p>
      <p class="text">6、迟到15分钟后不准进入考场参加当科目考试，交卷出场时间不得早于每科目考试结束前30分钟，交卷出场后不得再进场续考。</p>
      <p class="text">7、按照题号顺序在答题卡规定的区域答题，跨区域作答的无效。不准用规定以外的笔答题，不准在答题卡上做任何标记。</p>
      <input type="button" @click="toHome()" value="开始考试"/>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "notice",
  data() {
    return {
      name:'',
      exam_name:''
    }
  },
  mounted(){
    this.exam_name=sessionStorage.getItem('exam_name')
    this.name=sessionStorage.getItem('user_name')
  },
  methods:{
    toHome(){
      this.$router.replace('/exam')
    }
  }
}
</script>

<style scoped>
.wrap{
  height: 100%;
  background-image: url('/image/notice_bcg.jpg');
}
.notice{
  width: 60.4%;
  height: 100%;
  margin: 0 auto;
  /* border: 1px solid red; */
  padding: 2.0% 2.4%;
  font-size: 1rem;
  letter-spacing: 0rem;
  background: #fff;
}
em{
  font-style:normal;
  color: #ff3d3d;
}
.notice .title{
  text-align: center;
  color: #ff3d3d;
  font-size: 1.6rem;
  height: 5rem;
  line-height: 5rem;
}
.line{
  width: 100%;
  height: 2px;
  background: #ff3d3d;
}
.text{
  margin-top: 2.2rem;
}
.notice input{
  width: 15.5rem;
  height: 3.1rem;
  background: #4f93fe;
  color: #fff;
  margin-left: 50%;
  transform: translateX(-50%);
  margin-top: 4.68rem;
  border-radius: .2rem;
}

@media screen and (max-width:820px){
  .wrap,.notice{
    width: 100%;
    font-size: 4.3rem;
  }
  .wrap .notice p.title{
    font-size: 5rem;
    margin-top: 3rem;
    margin-bottom: 1.5rem;
  }
  .notice input{
    width: 35.5rem;
    height: 9.1rem;
    border-radius: 1.5rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 5rem;
  }
}
</style>